import { Button } from "antd";
import { APP_CONSTANTS } from "constants/AppConstants";
import { notificationController } from "controllers/notificationController";
import { useAppDispatch } from "hooks/reduxHooks";
import { OutLookSvgIcon } from "icons/Icons";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { doMicrosoftLogin } from "store/slices/authSlice";

const SSOMicrosoftLogin = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (code) handleCredentialResponse();
  }, [code]);

  function handleCredentialResponse() {
    const data = { code: code };
    setLoading(true);
    dispatch(doMicrosoftLogin(data))
      .unwrap()
      .then(() => {
        setLoading(false);
        const win: any = window;
        win.location = APP_CONSTANTS.index;
      })
      .catch(() => {
        setLoading(false);
        notificationController.error({
          message: "Something went wrong while logging in with Microsoft.",
        });
      });
  }

  const handleMicrosoftLogin = () => {
    const w: any = window;
    const redirectURL = encodeURIComponent(
      `${w.location.protocol}//${w.location.host}${w.location.pathname}`
    );

    w.location = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${APP_CONSTANTS.MICROSOFT_CLIENT_ID}&response_type=code&redirect_uri=${redirectURL}&response_mode=query&scope=openid%20offline_access%20https%3A%2F%2Fgraph.microsoft.com%2Fuser.read`;
  };

  return (
    <Button
      type="link"
      loading={loading}
      icon={<OutLookSvgIcon width={50} height={500}></OutLookSvgIcon>}
      className="m-soft-btn"
      onClick={handleMicrosoftLogin}
    >
      <span className="sp">Microsoft Login</span>
    </Button>
  );
};

export default SSOMicrosoftLogin;
